<template>
  <surround
    :surround-image="surroundImage"
    :back-link="backLink"
  >
    <div class="info-content">
      <h1>Live Like Roberto Burle Marx</h1>
      <ContentText>
        <center>
          <router-link
            :to="{name: 'burle-marx-live-sitio-intro'}"
            class="button"
          >
            A taste of the Sítio
          </router-link>
        </center>
      </ContentText>
      <ContentText>
        <center>
          <router-link
            :to="{name: 'burle-marx-live-playlist-intro'}"
            class="button"
          >
            Brazilian Playlist
          </router-link>
        </center>
      </ContentText>
      <ContentText>
        <center>
          <router-link
            :to="{name: 'burle-marx-live-game-intro'}"
            class="button"
          >
            Collection Expedition
          </router-link>
        </center>
      </ContentText>
    </div>
  </surround>
</template>

<script>
// import InspirationMap from './InspirationMap.vue'
export default {
  name: 'BurleMarxLive',
  props: {
    surroundImage: {
      type: String,
      default: ''
    },
    backLink: {
      type: [String, Object, Boolean],
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.info-content {
  @include flex-vertical;
  @include flex-fill-vertical;
  justify-content: center;
}
.button {
  width: 80%;
}
</style>
